module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "History__body"
  }, [_c('div', {
    staticClass: "History__body-container"
  }, [_c('div', {
    staticClass: "History__title"
  }, [_vm._v("\n      History\n    ")]), _vm._v(" "), (_vm.history.length) ? _c('div', {
    staticClass: "History__list"
  }, [_vm._l((_vm.history.groups), function(group, key) {
    return _c('div', [_c('span', {
      staticClass: "History__group-name"
    }, [_vm._v("\n          " + _vm._s(key) + "\n        ")]), _vm._v(" "), _vm._l((group), function(event) {
      return _c('div', {
        staticClass: "History__row"
      }, [_c('div', {
        staticClass: "History__row-info"
      }, [_c('div', {
        staticClass: "History__row-date"
      }, [_vm._v("\n              " + _vm._s(_vm._f("moment")(event.startTimeInMillis, "DD")) + "\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-info"
      }, [_c('div', {
        staticClass: "History__conference-title"
      }, [_vm._v("\n                " + _vm._s(event.title || 'Untitled') + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-started"
      }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(event.startTimeInMillis, "dddd, MMMM Do [at] h:mm a")) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-duration"
      }, [_vm._v("\n                " + _vm._s(event.duration) + "\n              ")])])]), _vm._v(" "), _c('transition-group', {
        staticClass: "History__row-attendees",
        attrs: {
          "name": "fade-in",
          "tag": "div"
        }
      }, [_c('span', {
        key: "title",
        staticClass: "History__row-attendees-title"
      }, [_vm._v("\n              " + _vm._s(event.attendeesUserIds.length) + " Attendees:\n            ")]), _vm._v(" "), _vm._l((event.attendees), function(attendant, key) {
        return _c('div', {
          key: key,
          staticClass: "History__attendant"
        }, [_vm._v("\n              " + _vm._s(attendant))])
      })], 2)], 1)
    })], 2)
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "historyLoading",
    staticClass: "History__infinite-loading-container",
    attrs: {
      "direction": "bottom",
      "spinner": "circles"
    },
    on: {
      "infinite": _vm.getHistory
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('i', {
    staticClass: "icon-ic_spinner History__loading"
  })])])], 2) : _vm._e(), _vm._v(" "), (!_vm.history.length && !_vm.initializing) ? _c('div', {
    staticClass: "History__empty-results"
  }, [_c('img', {
    staticClass: "History__empty-results-img",
    attrs: {
      "src": require("../../../../static/images/history_empty.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "History__empty-results-text"
  }, [_vm._v("\n        You haven’t held any meetings.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.initializing) ? _c('i', {
    staticClass: "icon-ic_spinner History__loading"
  }) : _vm._e()]), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": "KingsConference - History"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33939363","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/history-tab/history-tab.vue
// module id = 424
// module chunks = 1